import Reveal from '@/components/base/Reveal';
import { featuredChannels } from '@/mocks/home';

export default function FeaturedSection() {
  return (
    <section id="featured" className="w-full border-y border-background-300/70 bg-background-100 py-20 md:py-28">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6">
        <Reveal>
          <div className="flex flex-col gap-4 border-b border-background-300/70 pb-6 sm:flex-row sm:items-end sm:justify-between">
            <div>
              <div className="flex items-center gap-2 text-[12px] tracking-[0.28em] text-primary-600">
                <span className="h-px w-6 bg-primary-500" />
                03 / 分区入口
              </div>
              <h3 className="mt-3 font-heading text-[30px] font-black tracking-tight text-foreground-950 md:text-[40px]">
                分区精选
              </h3>
              <p className="mt-2 max-w-[560px] text-[14px] leading-relaxed text-foreground-600">
                按题材划分的内容分区，封面与主题一眼可辨，进入即看，无需付费也不设观看上限。
              </p>
            </div>
            <span className="shrink-0 text-[13px] text-foreground-500">共 9 个开放分区</span>
          </div>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          {featuredChannels.map((channel, index) => (
            <Reveal key={channel.name} delay={index * 80}>
              <article className="group h-full overflow-hidden rounded-lg border border-background-300/70 bg-background-50">
                <div className="relative h-[220px] w-full md:h-[240px]">
                  <img
                    src={channel.cover}
                    alt={`${channel.name}分区封面`}
                    title={`黑料免费 · ${channel.name}`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.04]"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-foreground-950/10 to-transparent" />
                  <span className="absolute left-4 top-4 flex h-10 w-10 items-center justify-center rounded-lg bg-background-50/95 text-primary-600">
                    <i className={`${channel.icon} text-[20px]`} />
                  </span>
                </div>
                <div className="p-5 md:p-6">
                  <div className="flex items-center justify-between">
                    <h4 className="font-heading text-[19px] font-bold text-foreground-950 md:text-[21px]">
                      {channel.name}
                    </h4>
                    <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-[12px] text-secondary-900">
                      {channel.count}
                    </span>
                  </div>
                  <p className="mt-2.5 text-[14px] leading-relaxed text-foreground-600">{channel.desc}</p>
                  <a
                    href="#latest"
                    className="mt-5 flex cursor-pointer items-center gap-1.5 whitespace-nowrap text-[14px] font-medium text-primary-600 transition-colors hover:text-primary-700"
                  >
                    进入分区
                    <span className="flex h-4 w-4 items-center justify-center">
                      <i className="ri-arrow-right-line text-[16px]" />
                    </span>
                  </a>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}